import {
  IApiOptions,
  IComputedMultipleOperationOrderItem,
  IComputedMultipleOperationOrderResponse,
  IMultipleOperationOrderItem,
  IMultipleOperationOrderResponse,
  IXSellyErrorResponse,
} from 'x/types'

import _ from 'lodash'
import * as util from 'x/utils/util'
import api from './api'

type IEditOrderShippingTypeParams = {
  store_id: number

  order_ids: number[]
  new_shipping_type_id: number
}

export async function editOrderShippingType(params: IEditOrderShippingTypeParams): Promise<IComputedMultipleOperationOrderResponse> {
  const { store_id, order_ids, new_shipping_type_id } = params

  if (!store_id) {
    throw new Error('editOrderShippingType:: Need store_id')
  }

  if (!order_ids || order_ids.length === 0) {
    throw new Error('editOrderShippingType:: Need order_ids')
  }

  if (!new_shipping_type_id) {
    throw new Error('editOrderShippingType:: Need new_shipping_type_id')
  }

  const apiOptions: IApiOptions = {
    // messages: {
    //   successMsg: 'แก้ไขรูปแบบจัดส่งสำเร็จ',
    //   errorMsg: 'แก้ไขรูปแบบจัดส่งไม่สำเร็จ',
    // },
    axiosOptions: {
      timeout: 60000,
    },
    showSpinner: false,
    isApiV2: true,
  }

  try {
    // console.log('In editOrderShippingType:: reqBody => ', reqBody)
    const res = await api.post<IEditOrderShippingTypeParams, IMultipleOperationOrderResponse>(
      'order/edit_shipping_type',
      params,
      apiOptions
    )
    // console.log('In editOrderShippingType:: response => ', res)

    if (!res.total_order_count) {
      throw new Error('editOrderShippingType:: No "total_order_count" in response')
    }

    return computeMultipleOrderErrorsFromResponse(res)
  } catch (err) {
    console.log('In editOrderShippingType:: err => ', err)
    throw err
  }
}

type IOrderAutoCompleteShippingsParams = {
  store_id: number
  order_ids: number[]

  force_create?: boolean
  create_shipping_only_with_xshipping?: boolean
}

export async function orderAutoCompleteShippings(
  params: IOrderAutoCompleteShippingsParams
): Promise<IComputedMultipleOperationOrderResponse> {
  const { store_id, order_ids, force_create, create_shipping_only_with_xshipping } = params

  if (!store_id) {
    throw new Error('orderAutoCompleteShippings:: Need store_id')
  }

  if (!order_ids || order_ids.length === 0) {
    throw new Error('orderAutoCompleteShippings:: Need order_ids')
  }

  const apiOptions: IApiOptions = {
    axiosOptions: {
      timeout: 60000,
    },
    showSpinner: false,
    isApiV2: true,
  }

  try {
    const reqBody: IOrderAutoCompleteShippingsParams = {
      store_id,
      order_ids,
    }

    if (force_create) {
      reqBody.force_create = force_create
    }

    if (create_shipping_only_with_xshipping) {
      reqBody.create_shipping_only_with_xshipping = create_shipping_only_with_xshipping
    }

    // console.log('In orderAutoCompleteShippings:: reqBody => ', reqBody)
    const res = await api.post<IOrderAutoCompleteShippingsParams, IMultipleOperationOrderResponse>(
      'order/auto_complete_shippings',
      reqBody,
      apiOptions
    )
    // console.log('In orderAutoCompleteShippings:: response => ', res)

    if (!res.total_order_count) {
      throw new Error('orderAutoCompleteShippings:: No "total_order_count" in response')
    }

    return computeMultipleOrderErrorsFromResponse(res)
  } catch (err) {
    console.log('In orderAutoCompleteShippings:: err => ', err)
    throw err
  }
}

type IOrderCancelXShippingsParams = {
  store_id: number
  order_ids: number[]
}

export async function orderCancelXShippings(params: IOrderCancelXShippingsParams): Promise<IComputedMultipleOperationOrderResponse> {
  const { store_id, order_ids } = params

  if (!store_id) {
    throw new Error('orderCancelXShippings:: Need store_id')
  }

  if (!order_ids || order_ids.length === 0) {
    throw new Error('orderCancelXShippings:: Need order_ids')
  }

  const apiOptions: IApiOptions = {
    axiosOptions: {
      timeout: 60000,
    },
    showSpinner: false,
    isApiV2: true,
  }

  try {
    const reqBody: IOrderCancelXShippingsParams = {
      store_id,
      order_ids,
    }

    // console.log('In orderCancelXShippings:: reqBody => ', reqBody)
    const res = await api.post<IOrderCancelXShippingsParams, IMultipleOperationOrderResponse>(
      'order/cancel_xshippings',
      reqBody,
      apiOptions
    )
    // console.log('In orderCancelXShippings:: response => ', res)

    if (!res.total_order_count) {
      throw new Error('orderCancelXShippings:: No "total_order_count" in response')
    }

    return computeMultipleOrderErrorsFromResponse(res)
  } catch (err) {
    console.log('In orderCancelXShippings:: err => ', err)
    throw err
  }
}

type IOrderUpdateXShippingsParams = {
  store_id: number
  order_ids: number[]
}

export async function orderUpdateXShippings(params: IOrderUpdateXShippingsParams): Promise<IComputedMultipleOperationOrderResponse> {
  const { store_id, order_ids } = params

  if (!store_id) {
    throw new Error('orderUpdateXShippings:: Need store_id')
  }

  if (!order_ids || order_ids.length === 0) {
    throw new Error('orderUpdateXShippings:: Need order_ids')
  }

  const apiOptions: IApiOptions = {
    axiosOptions: {
      timeout: 60000,
    },
    showSpinner: false,
    isApiV2: true,
  }

  try {
    const reqBody: IOrderUpdateXShippingsParams = {
      store_id,
      order_ids,
    }

    // console.log('In orderUpdateXShippings:: reqBody => ', reqBody)
    const res = await api.post<IOrderUpdateXShippingsParams, IMultipleOperationOrderResponse>(
      'order/update_xshippings',
      reqBody,
      apiOptions
    )
    // console.log('In orderUpdateXShippings:: response => ', res)

    if (!res.total_order_count) {
      throw new Error('orderUpdateXShippings:: No "total_order_count" in response')
    }

    return computeMultipleOrderErrorsFromResponse(res)
  } catch (err) {
    console.log('In orderUpdateXShippings:: err => ', err)
    throw err
  }
}

type IOrderCreateXShippingsParams = {
  store_id: number
  order_ids: number[]
}

export async function orderCreateXShippings(params: IOrderCreateXShippingsParams): Promise<IComputedMultipleOperationOrderResponse> {
  const { store_id, order_ids } = params

  if (!store_id) {
    throw new Error('orderCreateXShippings:: Need store_id')
  }

  if (!order_ids || order_ids.length === 0) {
    throw new Error('orderCreateXShippings:: Need order_ids')
  }

  const apiOptions: IApiOptions = {
    axiosOptions: {
      timeout: 60000,
    },
    showSpinner: false,
    isApiV2: true,
  }

  try {
    const reqBody: IOrderCreateXShippingsParams = {
      store_id,
      order_ids,
    }

    // console.log('In orderCreateXShippings:: reqBody => ', reqBody)
    const res = await api.post<IOrderCreateXShippingsParams, IMultipleOperationOrderResponse>(
      'order/create_xshippings',
      reqBody,
      apiOptions
    )
    // console.log('In orderCreateXShippings:: response => ', res)

    if (!res.total_order_count) {
      throw new Error('orderCreateXShippings:: No "total_order_count" in response')
    }

    return computeMultipleOrderErrorsFromResponse(res)
  } catch (err) {
    console.log('In orderCreateXShippings:: err => ', err)
    throw err
  }
}

type IOrderCancelShippingsParams = {
  store_id: number
  order_ids: number[]
}

export async function orderCancelShippings(params: IOrderCancelShippingsParams): Promise<IComputedMultipleOperationOrderResponse> {
  const { store_id, order_ids } = params

  if (!store_id) {
    throw new Error('orderCancelShippings:: Need store_id')
  }

  if (!order_ids || order_ids.length === 0) {
    throw new Error('orderCancelShippings:: Need order_ids')
  }

  const apiOptions: IApiOptions = {
    axiosOptions: {
      timeout: 60000,
    },
    showSpinner: false,
    isApiV2: true,
  }

  try {
    const reqBody: IOrderCancelShippingsParams = {
      store_id,
      order_ids,
    }

    // console.log('In orderCancelShippings:: reqBody => ', reqBody)
    const res = await api.post<IOrderCancelShippingsParams, IMultipleOperationOrderResponse>('order/cancel_shippings', reqBody, apiOptions)
    // console.log('In orderCancelShippings:: response => ', res)

    if (!res.total_order_count) {
      throw new Error('orderCancelShippings:: No "total_order_count" in response')
    }

    return computeMultipleOrderErrorsFromResponse(res)
  } catch (err) {
    console.log('In orderCancelShippings:: err => ', err)
    throw err
  }
}

type IOrderEditOrderAddressParams = {
  store_id: number
  order_ids: number[]
  new_address_id: number
  type?: 'SENDER' | 'RECEIVER' // Optional, default is 'SENDER'
}

export async function orderEditOrderAddress(params: IOrderEditOrderAddressParams): Promise<IComputedMultipleOperationOrderResponse> {
  const { store_id, order_ids, new_address_id, type = 'SENDER' } = params

  if (!store_id) {
    throw new Error('orderEditOrderAddress:: Need store_id')
  }

  if (!order_ids || order_ids.length === 0) {
    throw new Error('orderEditOrderAddress:: Need order_ids')
  }

  if (!new_address_id) {
    throw new Error('orderEditOrderAddress:: Need new_address_id')
  }

  const apiOptions: IApiOptions = {
    axiosOptions: {
      timeout: 60000,
    },
    showSpinner: false,
    isApiV2: true,
  }

  try {
    const reqBody: IOrderEditOrderAddressParams = {
      store_id,
      order_ids,
      new_address_id,
      type,
    }

    // console.log('In orderEditOrderAddress:: reqBody => ', reqBody)
    const res = await api.post<IOrderEditOrderAddressParams, IMultipleOperationOrderResponse>('order/edit_address', reqBody, apiOptions)
    // console.log('In orderEditOrderAddress:: response => ', res)

    if (!res.total_order_count) {
      throw new Error('orderEditOrderAddress:: No "total_order_count" in response')
    }

    return computeMultipleOrderErrorsFromResponse(res)
  } catch (err) {
    console.log('In orderEditOrderAddress:: err => ', err)
    throw err
  }
}

// ---------------------------------------------------------------------------------------------
function computeMultipleOrderErrorsFromResponse(res: IMultipleOperationOrderResponse): IComputedMultipleOperationOrderResponse {
  const newRes = _.cloneDeep(res)

  if ('orders' in newRes) {
    newRes.orders = newRes.orders.map((od) => {
      const newOd = { ...od } as IComputedMultipleOperationOrderItem
      if ('error' in od) {
        newOd.errorMessage = computeMultipleOperationOrderError(od)
      }
      return newOd
    })
  }

  return newRes
}

function computeMultipleOperationOrderError(od: IMultipleOperationOrderItem): { title: string; message: string } {
  if (util.isXSellyErrorV2(od.error as IXSellyErrorResponse)) {
    // @ts-ignore
    const title = util.parseXSellyErrorToTitleText(od.error.error)
    // @ts-ignore
    const message = util.parseXSellyErrorToMessageText(od.error.error)

    if (_.isString(title) && _.isString(message)) {
      return {
        title,
        message,

        // @ts-ignore
        error: od.error,
        // @ts-ignore
        isErrorV2: true,
      }
    }
  }

  if (util.isXSellyErrorV1(od.error as IXSellyErrorResponse)) {
    const parsedOldErrorMessage = util.getErrMessageObj(od.error as IXSellyErrorResponse, '')
    if (
      parsedOldErrorMessage &&
      parsedOldErrorMessage.title &&
      _.isString(parsedOldErrorMessage.msg) &&
      parsedOldErrorMessage.msg.length > 0
    ) {
      return {
        title: parsedOldErrorMessage.title,
        message: parsedOldErrorMessage.msg,

        // @ts-ignore
        error: od.error,
        // @ts-ignore
        isErrorV1: true,
      }
    }
  }

  if (util.isXSellyApiErrorCode(od.error as string)) {
    // console.log('In computeMultipleOperationOrderError:: od.error => ', od.error)
    const title = util.parseXSellyErrorKeyToTitleText(od.error as string)
    // console.log('In computeMultipleOperationOrderError:: od.error tt => ', tt)
    const message = util.parseXSellyErrorKeyToMessageText(od.error as string)
    // console.log('In computeMultipleOperationOrderError:: od.error mm => ', mm)

    if (_.isString(title) && _.isString(message)) {
      return {
        title,
        message,

        // @ts-ignore
        error: od.error,
        // @ts-ignore
        isErrorCodeSpecificError: true,
      }
    }

    const genericError = util.getErrMessageObj({ error: { error_code: od.error as string, status_code: 400 } }, '')
    // console.log('In computeMultipleOperationOrderError:: genericError => ', genericError)

    if (genericError && _.isString(genericError.title) && _.isString(genericError.msg) && genericError.msg.length > 0) {
      return {
        title: genericError.title,
        message: genericError.msg,

        // @ts-ignore
        error: od.error,
        // @ts-ignore
        isErrorCodeGenericError: true,
      }
    }
  }

  return {
    title: 'ไม่สามารถระบุข้อผิดพลาดได้',
    message: `(${JSON.stringify(od.error)})`,

    // @ts-ignore
    isErrorCannotDecoded: true,
  }
}

type IorderSendLineLonMessagesParams = {
  store_id: number
  order_ids: number[]
  line_lon_remark_template_id: number
}

export async function orderSendLineLonMessages(params: IorderSendLineLonMessagesParams): Promise<IComputedMultipleOperationOrderResponse> {
  const { store_id, order_ids, line_lon_remark_template_id } = params

  if (!store_id) {
    throw new Error('orderSendLineLonMessages:: Need store_id')
  }

  if (!order_ids || order_ids.length === 0) {
    throw new Error('orderSendLineLonMessages:: Need order_ids')
  }

  if (!line_lon_remark_template_id) {
    throw new Error('orderSendLineLonMessages:: Need line_lon_remark_template_id')
  }

  const apiOptions: IApiOptions = {
    axiosOptions: {
      timeout: 60000,
    },
    showSpinner: false,
    isApiV2: true,
  }

  try {
    const reqBody: IorderSendLineLonMessagesParams = {
      store_id,
      order_ids,
      line_lon_remark_template_id,
    }

    console.log('In orderSendLineLonMessages:: reqBody => ', reqBody)
    const res = await api.post<IorderSendLineLonMessagesParams, IMultipleOperationOrderResponse>(
      'order/send_line_lon_msgs',
      reqBody,
      apiOptions
    )
    console.log('In orderSendLineLonMessages:: response => ', res)

    if (!res.total_order_count) {
      throw new Error('orderSendLineLonMessages:: No "total_order_count" in response')
    }

    return computeMultipleOrderErrorsFromResponse(res)
  } catch (err) {
    console.log('In orderSendLineLonMessages:: err => ', err)
    throw err
  }
}
